import { useProductUrgencyLabel } from "@/hooks/useUrgency";

/**
 * Admin-authored "selling fast" style label for a product.
 *
 * The text is typed by an operator in the admin panel. It is deliberately
 * NOT derived from inventory, so real stock and this label are independent.
 */
export function UrgencyLabel({
  handle,
  className = "",
}: {
  handle: string | undefined;
  className?: string;
}) {
  const label = useProductUrgencyLabel(handle);
  if (!label) return null;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full bg-amber-500/12 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-amber-700 ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden />
      {label.label}
    </span>
  );
}
